export const APP_MAX_WIDTH = 1024;
export const DIALOG_MAX_WIDTH = 924;
export const DIALOG_MAX_HEIGHT = 580;
export const DIALOG_MIN_HEIGHT = 480;
